export default __webpack_public_path__ + "static/media/computadores.064d941d.jpg";